/**
 * Shared formatting utilities
 */

/**
 * Format a number as Indian currency.
 * - Integers show no decimal (₹1,23,456)
 * - Fractional values show 2 decimal places only when needed
 * - Returns null/undefined as dash
 */
export function fmtINR(n, { colored = false, showZero = false, decimals = 'auto' } = {}) {
  if (n === null || n === undefined) return null; // caller renders as —

  const num = Number(n);

  if (isNaN(num)) return null;

  // Decide decimal places
  let decOpt;
  if (decimals === 'auto') {
    // Show .xx only if there's a meaningful fractional part
    const frac = Math.abs(num) % 1;
    decOpt = frac < 0.005 ? { minimumFractionDigits: 0, maximumFractionDigits: 0 }
                          : { minimumFractionDigits: 2, maximumFractionDigits: 2 };
  } else {
    decOpt = { minimumFractionDigits: decimals, maximumFractionDigits: decimals };
  }

  const abs = Math.abs(num);
  const str = '₹' + abs.toLocaleString('en-IN', decOpt);

  if (!colored) {
    if (num < 0) return '-' + str;
    return str;
  }

  // colored JSX — import React in caller
  return { value: str, num, negative: num < 0, zero: num === 0 };
}

/**
 * Format integer count — no decimals, Indian locale
 */
export function fmtCount(n) {
  if (n === null || n === undefined) return '—';
  return Number(n).toLocaleString('en-IN');
}

/**
 * Format date string (ISO) → "15 Jun 2025"
 */
export function fmtDate(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
}

/**
 * Get today as YYYY-MM-DD
 */
export function todayStr() {
  return new Date().toISOString().slice(0, 10);
}

/**
 * Get FY start as YYYY-MM-DD (April 1)
 */
export function fyStart() {
  const d = new Date();
  const y = d.getMonth() >= 3 ? d.getFullYear() : d.getFullYear() - 1;
  return `${y}-04-01`;
}
